module.exports = __webpack_public_path__ + "static/media/bar-brewery-winery-3.348e070d.jpg";